import { Component, Renderer, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Router, Route } from '@angular/router';
import { PopoverEditableDropDownComponentBase } from './popover-editable-dropdown.base.component';
import { CommonService } from '../../_services';
import { IChangeCallback } from '../../_entities';

@Component({

    selector: 'popover-editable-generic-dropdown',
    template: require('./popover-editable-generic-dropdown.template.html')
})

export class PopoverEditableGenericDropDownComponent extends PopoverEditableDropDownComponentBase<any> {
    @Input() idProperty = "id";
    @Input() nameProperty = "name";
    @Input() tuples: Promise<any[]> | any[];
    @Input() addNewOption: boolean = false;
    @Input() addDialogRoute: any;
    @Output() addCallback = new EventEmitter<any>();

    dropdownItems: any[];
    newItemNameValue: string;

    addNewValue = { val: 'new' };
    newValue: string;
    get showAddNewValue(): boolean {
        return this.selectedItem == this.addNewValue;
    };

    constructor(
        private readonly commonService: CommonService,
        protected renderer: Renderer,
        protected element: ElementRef,
        private readonly router: Router) {
        super(renderer, element);
    }

    onSelectChange(event) {
        console.log("onSelectChange", this.selectedItem == this.addNewValue);

        if (!this.showAddNewValue) {
            this.onChange();
            return;
        }
        if (this.addDialogRoute == null) {
            return;
        }
        // Navigate to route
        //console.log("Show content of show route in router outlet", this.addDialogRoute);
        //this.router.navigate([], { })
        //this.router.navigate([this.addDialogRoute]);

    }

    onAddNewValue(event) {
        this.addCallback.emit(this.newValue);
    }

    onCancelNewValue(event) {
        this.newValue = this.selectedItem = null;
        event.stopPropagation();
    }

    protected getItems(): Promise<number[]> {
        if (this.tuples instanceof Promise) {
            return this.tuples.then(result => {
                this.dropdownItems = result;
                return this.dropdownItems.map(r => r[this.idProperty]);
            });
        } else if (this.tuples != null) {
            this.dropdownItems = this.tuples;
            return Promise.resolve(this.dropdownItems.map(r => r[this.idProperty]));
        } else {
            return Promise.resolve(null);
        }

    }

    protected mapItem(items: number[], item: any): any {
        return items.find(x => x == item);
    }

    protected getValue(itemToFind: any): any {
        return itemToFind && this.dropdownItems ? this.dropdownItems.find(x => x[this.idProperty] == itemToFind) : null;
    }

    protected getDisplayValue(itemToFind: any) {

        const item = this.getValue(itemToFind);
        if (item) {
            return item[this.nameProperty];
        }
        if (itemToFind == null) {
            return null;
        }
        return itemToFind + "";

    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/popover-editable-generic-dropdown.component.ts